export default __webpack_public_path__ + "static/media/img-0567-finland-half-face.fe35cf0a.png";